import { render } from "./shy.vue?vue&type=template&id=e7c7b8c8&scoped=true"
import script from "./shy.vue?vue&type=script&lang=js"
export * from "./shy.vue?vue&type=script&lang=js"

import "./shy.vue?vue&type=style&index=0&id=e7c7b8c8&lang=scss&scoped=true"

import exportComponent from "/var/www/toll-collector/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7c7b8c8"]])

export default __exports__